import { render } from "./PayBtn.vue?vue&type=template&id=90962a7a"
import script from "./PayBtn.vue?vue&type=script&lang=js"
export * from "./PayBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__